import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreePickerSingleDirectionType, TreePickerSingleDirectionEnum } from '../tree-picker-single/tree-picker-single.component';

@Component({
  selector: 'siu-tree-picker-action-buttons',
  templateUrl: './tree-picker-action-buttons.component.html',
  styleUrls: [ './tree-picker-action-buttons.component.scss' ]
})
export class TreePickerActionButtonsComponent implements OnInit {

  @Input() direction: TreePickerSingleDirectionType;

  @Output('on-add') OnAddEvent: EventEmitter<any> = new EventEmitter();

  @Output('on-remove') OnRemoveEvent: EventEmitter<any> = new EventEmitter();

  @Input() disabled: boolean;

  DirectionIsInput: boolean;

  @Input() sideDirection: 'ltr' | 'rtl' = 'ltr';

  constructor() { }

  ngOnInit() {
    this.DirectionIsInput = this.direction === TreePickerSingleDirectionEnum.INPUT;
  }

  HandleAdd = () => {
    this.OnAddEvent.emit();
  }

  HandleRemove = () => {
    this.OnRemoveEvent.emit();
  }

}
